import { buildModelManager } from "../builder.js";
const DefaultQaRoutingAssignmentSelection = {
  __typename: true,
  id: true,
  active: true,
  activeDomains: true,
  assignmentContext: true,
  createdAt: true,
  deliveryOverride: true,
  groupId: true,
  notificationPreferences: true,
  notifyOn: true,
  releaseAuthorityByDomain: true,
  routingRoleId: true,
  updatedAt: true,
  userId: true,
  visibilityOverride: true,
  workflowId: true
};
const modelApiIdentifier = "qaRoutingAssignment";
const pluralModelApiIdentifier = "qaRoutingAssignments";
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultQaRoutingAssignmentSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultQaRoutingAssignmentSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultQaRoutingAssignmentSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultQaRoutingAssignmentSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultQaRoutingAssignmentSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultQaRoutingAssignmentSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultQaRoutingAssignmentSelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "qaRoutingAssignmentGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const QaRoutingAssignmentManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultQaRoutingAssignmentSelection,
  operations
);
export {
  DefaultQaRoutingAssignmentSelection,
  QaRoutingAssignmentManager
};
//# sourceMappingURL=QaRoutingAssignment.js.map
